import { render, staticRenderFns } from "./my_index.vue?vue&type=template&id=2b90b5c8&scoped=true"
import script from "./my_index.vue?vue&type=script&lang=js"
export * from "./my_index.vue?vue&type=script&lang=js"
import style0 from "./my_index.vue?vue&type=style&index=0&id=2b90b5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b90b5c8",
  null
  
)

export default component.exports